"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rocca-sinibalda": {
    "4f24a7da": [{
      "hkey": "de80d202",
      "slug": "rocca-sinibalda",
      "name": "Rocca Sinibalda",
      "primary": true,
      "skipSearch": false
    }],
    "granica": [{
      "hkey": "de80d202",
      "slug": "rocca-sinibalda",
      "name": "Rocca Sinibalda",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;